"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _dayjs = _interopRequireDefault(require("dayjs"));

var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faTimes = require("@fortawesome/pro-regular-svg-icons/faTimes");

var _peractoConfig = require("@peracto/peracto-config");

var _peractoEditorUi = require("@peracto/peracto-editor-ui");

var _peractoUi = require("@peracto/peracto-ui");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var S = _interopRequireWildcard(require("./styled"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ContentProductRelationships = _interopRequireDefault(require("./ContentProductRelationships"));

var _BackgroundImageOptions = _interopRequireDefault(require("./BackgroundImageOptions"));

var _AccountNumberRestrictions = _interopRequireDefault(require("./AccountNumberRestrictions"));

var _UserGroupRestrictions = _interopRequireDefault(require("./UserGroupRestrictions"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var TextArea = function TextArea(_ref) {
  var label = _ref.label,
      value = _ref.value,
      onChange = _ref.onChange;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-group",
    "data-testid": "".concat(label.toLowerCase().replaceAll(' ', '-'), "-section")
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "mb-1"
  }, label), /*#__PURE__*/_react["default"].createElement("textarea", {
    className: "form-control",
    rows: 6,
    "data-testid": label.toLowerCase().replaceAll(' ', '-'),
    value: value,
    onChange: onChange
  }));
};

var LeftPanel = function LeftPanel(_ref2) {
  var _content$productRelat, _localeOptions;

  var showSettings = _ref2.showSettings,
      settings = _ref2.settings,
      setSettings = _ref2.setSettings,
      _ref2$contentType = _ref2.contentType,
      contentType = _ref2$contentType === void 0 ? 'page' : _ref2$contentType;
  var config = (0, _peractoConfig.useConfig)();

  var _config$get = config.get('editorConfig'),
      locales = _config$get.locales,
      restrictedCountries = _config$get.restrictedCountries;

  var _config$get2 = config.get('features', {}),
      article = _config$get2.article,
      content = _config$get2.content;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      settingsDate = _useState2[0],
      setSettingsDate = _useState2[1];

  var _useState3 = (0, _react.useState)(settings.type),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedFilter = _useState4[0],
      setSelectedFilter = _useState4[1];

  (0, _react.useEffect)(function () {
    setSelectedFilter(settings.type);
  }, [settings.type]);

  var FilterToggle = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        button {\n            appearance: none;\n            border: 1px solid #6c757d;\n            color: #6c757d;\n            height: 38px;\n            width: 82px;\n            background-color: transparent;\n\n            &:active,\n            &:focus {\n                outline: none;\n            }\n\n            &.selected {\n                background-color: #6c757d;\n                color: #ddd;\n            }\n\n            &:first-child {\n                border-radius: 3px 0 0 3px;\n            }\n\n            &:last-child {\n                border-radius: 0 3px 3px 0;\n            }\n        }\n    "])));

  var StyledDateInput = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        display: flex;\n\n        .react-datepicker-wrapper {\n            display: block;\n            width: 100%;\n            flex-grow: 1;\n        }\n    "])));

  (0, _react.useEffect)(function () {
    if (!!settings.publishedAt === false) {
      setSettingsDate(null);
    } else {
      setSettingsDate(new Date(settings.publishedAt));
    }
  }, [settings.publishedAt]);
  var localeOptions;

  if (locales) {
    localeOptions = locales.map(function (locale) {
      return {
        label: locale,
        value: locale
      };
    });
  } else {
    localeOptions = [{
      label: 'en_GB',
      value: 'en_GB'
    }];
  }

  var showProductRelationship = (content === null || content === void 0 ? void 0 : (_content$productRelat = content.productRelationships) === null || _content$productRelat === void 0 ? void 0 : _content$productRelat.hasOwnProperty(contentType)) && content.productRelationships[contentType] === true;
  var showBabbageAccountRestrictions = content === null || content === void 0 ? void 0 : content.restrictByAccountNumber;
  var showUserGroupRestrictions = content === null || content === void 0 ? void 0 : content.restrictByUserGroup;
  (0, _react.useEffect)(function () {
    document.getElementsByClassName('datepicker__start-date form-control')[0].setAttribute('data-testid', 'published-at-field');
  }, [StyledDateInput]);
  var monthOption = {
    month: 'long'
  };

  var renderDayContents = function renderDayContents(day, date) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      "data-testid": "date-".concat(Intl.DateTimeFormat(localeOptions.value, monthOption).format(date).toLowerCase(), "-").concat(day)
    }, date.getDate());
  };

  var renderCustomHeader = function renderCustomHeader(_ref3) {
    var date = _ref3.date,
        customHeaderCount = _ref3.customHeaderCount,
        decreaseMonth = _ref3.decreaseMonth,
        increaseMonth = _ref3.increaseMonth;
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
      "aria-label": "Previous Month",
      className: 'react-datepicker__navigation react-datepicker__navigation--previous',
      "data-testid": "previous-month",
      style: customHeaderCount === 1 ? {
        visibility: 'hidden'
      } : null,
      onClick: decreaseMonth
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: 'react-datepicker__navigation-icon react-datepicker__navigation-icon--previous'
    }, '<')), /*#__PURE__*/_react["default"].createElement("span", {
      className: "react-datepicker__current-month",
      "data-testid": "current-month"
    }, Intl.DateTimeFormat(localeOptions.value, monthOption).format(date)), /*#__PURE__*/_react["default"].createElement("button", {
      "aria-label": "Next Month",
      className: 'react-datepicker__navigation react-datepicker__navigation--next',
      style: customHeaderCount === 0 ? {
        visibility: 'hidden'
      } : null,
      onClick: increaseMonth,
      "data-testid": "next-month"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: 'react-datepicker__navigation-icon react-datepicker__navigation-icon--next'
    }, '>')));
  };

  return /*#__PURE__*/_react["default"].createElement(S.LeftPanel, {
    className: (0, _classnames["default"])({
      active: showSettings
    }),
    "data-testid": "left-panel"
  }, /*#__PURE__*/_react["default"].createElement(_peractoEditorUi.TextInput, {
    label: contentType === 'article' || 'blog' ? 'Heading' : 'Name',
    "data-testid": contentType === 'article' ? 'content-heading' : 'content-name',
    value: settings.name,
    onChange: function onChange(e) {
      setSettings(_objectSpread(_objectSpread({}, settings), {}, {
        name: e.target.value,
        heading: e.target.value
      }));
    },
    onBlur: function onBlur(e) {
      if (!settings.slug && e.target.value.length > 0) {
        var slug = encodeURI(e.target.value.split(' ').join('-').replace(/[`~!@#$£€%^&*_|+=?;:'",.()<>\{\}\[\]\\\/]/gi, '').replace(/-+/g, '-').toLowerCase());
        setSettings(_objectSpread(_objectSpread({}, settings), {}, {
          slug: slug
        }));
      }
    }
  }), (contentType === 'article' || 'blog') && /*#__PURE__*/_react["default"].createElement(TextArea, {
    label: "Short Description",
    value: settings.shortDescription || '',
    onChange: function onChange(e) {
      return setSettings(_objectSpread(_objectSpread({}, settings), {}, {
        shortDescription: e.target.value
      }));
    }
  }), !['template', 'element'].includes(contentType) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_peractoEditorUi.TextInput, {
    label: "Title",
    "data-testid": "content-title",
    value: settings.title.length > 0 ? settings.title : '',
    onChange: function onChange(e) {
      setSettings(_objectSpread(_objectSpread({}, settings), {}, {
        title: e.target.value
      }));
    }
  }), /*#__PURE__*/_react["default"].createElement(TextArea, {
    label: "Meta Description",
    "data-testid": "content-meta-desc",
    value: settings.metaDescription || '',
    onChange: function onChange(e) {
      return setSettings(_objectSpread(_objectSpread({}, settings), {}, {
        metaDescription: e.target.value
      }));
    }
  })), ['page', 'article', 'blog', 'template'].includes(contentType) && /*#__PURE__*/_react["default"].createElement(_peractoUi.TagsList, {
    label: "Keywords",
    testId: "keywords-field",
    value: settings.keywords,
    onChange: function onChange(tags) {
      setSettings(_objectSpread(_objectSpread({}, settings), {}, {
        keywords: tags
      }));
    }
  }), ['page', 'article', 'blog'].includes(contentType) && (content === null || content === void 0 ? void 0 : content.indexContent) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/_react["default"].createElement(_peractoEditorUi.Checkbox, {
    label: "Exclude From Search",
    checked: !settings.searchable,
    onChange: function onChange(e) {
      return setSettings(_objectSpread(_objectSpread({}, settings), {}, {
        searchable: !e.target.checked
      }));
    }
  })), !['template', 'element'].includes(contentType) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_peractoEditorUi.File, {
    label: "Image",
    value: settings.image,
    showThumbnail: true,
    onChange: function onChange(value) {
      return setSettings(_objectSpread(_objectSpread({}, settings), {}, {
        image: value
      }));
    },
    "data-testid": "content-image"
  }), /*#__PURE__*/_react["default"].createElement(_peractoEditorUi.TextInput, {
    label: "Slug",
    "data-testid": "content-slug",
    value: settings.slug,
    onChange: function onChange(e) {
      return setSettings(_objectSpread(_objectSpread({}, settings), {}, {
        slug: e.target.value
      }));
    },
    onBlur: function onBlur(e) {
      if (e.target.value.length > 0) {
        var slug = encodeURI(e.target.value.split(' ').join('-').replace(/[`~!@#$£€%^&*_|+=?;:'",.()<>\{\}\[\]\\\/]/gi, '').replace(/-+/g, '-').toLowerCase());
        setSettings(_objectSpread(_objectSpread({}, settings), {}, {
          slug: slug
        }));
      }
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-group",
    "data-testid": "published-at-section"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "mb-1"
  }, "Published At"), /*#__PURE__*/_react["default"].createElement(StyledDateInput, {
    "data-testid": "published-at"
  }, /*#__PURE__*/_react["default"].createElement(_reactDatepicker["default"], {
    renderCustomHeader: renderCustomHeader,
    renderDayContents: renderDayContents,
    className: "datepicker__start-date form-control",
    selected: settingsDate,
    onChange: function onChange(date) {
      setSettingsDate(date > 0 ? date : null);
      setSettings(_objectSpread(_objectSpread({}, settings), {}, {
        publishedAt: date > 0 ? (0, _dayjs["default"])(new Date(date)).format() : null
      }));
    },
    dateFormat: "dd/MM/yyyy HH:mm",
    showTimeSelect: true,
    timeFormat: "HH:mm",
    timeCaption: "Time"
  }), /*#__PURE__*/_react["default"].createElement("button", {
    className: "ml-2 btn btn-outline-secondary text-nowrap",
    onClick: function onClick() {
      setSettings(_objectSpread(_objectSpread({}, settings), {}, {
        publishedAt: null
      }));
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faTimes.faTimes,
    className: "mr-1"
  }), "Clear"))), ((_localeOptions = localeOptions) === null || _localeOptions === void 0 ? void 0 : _localeOptions.length) > 1 && /*#__PURE__*/_react["default"].createElement(_peractoEditorUi.Select, {
    label: "Locale",
    testId: "locale-dropdown",
    value: settings.locale,
    onChange: function onChange(e) {
      return setSettings(_objectSpread(_objectSpread({}, settings), {}, {
        locale: e.value
      }));
    },
    options: localeOptions
  }), (article === null || article === void 0 ? void 0 : article.blogToggle) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, ['article', 'blog'].includes(contentType) && (content === null || content === void 0 ? void 0 : content.indexContent) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-group",
    "data-testid": "article-toggle"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "mb-1"
  }, "This content is an: \xA0"), /*#__PURE__*/_react["default"].createElement(FilterToggle, null, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      setSelectedFilter('article');
      setSettings(_objectSpread(_objectSpread({}, settings), {}, {
        type: 'article'
      }));
    },
    className: selectedFilter === 'article' ? 'selected' : '',
    "data-testid": "filter-article"
  }, "Article"), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      setSelectedFilter('blog');
      setSettings(_objectSpread(_objectSpread({}, settings), {}, {
        type: 'blog'
      }));
    },
    className: selectedFilter === 'blog' ? 'selected' : '',
    "data-testid": "filter-blog"
  }, "Blog")))), !['template', 'element'].includes(contentType) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement(_BackgroundImageOptions["default"], {
    settings: settings,
    setSettings: setSettings,
    canContainBackground: contentType === 'article' || 'blog'
  })), showProductRelationship && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("hr", {
    className: "mt-4"
  }), /*#__PURE__*/_react["default"].createElement(_ContentProductRelationships["default"], {
    settings: settings,
    setSettings: setSettings
  })), (restrictedCountries === null || restrictedCountries === void 0 ? void 0 : restrictedCountries.length) > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("hr", {
    className: "mt-4"
  }), /*#__PURE__*/_react["default"].createElement(_peractoEditorUi.Select, {
    label: "Restrict to Country",
    testId: "country-restriction-dropdown",
    value: settings.countryCode,
    onChange: function onChange(e) {
      return setSettings(_objectSpread(_objectSpread({}, settings), {}, {
        countryCode: e.value
      }));
    },
    options: [{
      label: 'All',
      value: 'all'
    }].concat(_toConsumableArray(restrictedCountries))
  })), showBabbageAccountRestrictions && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("hr", {
    className: "mt-4"
  }), /*#__PURE__*/_react["default"].createElement(_AccountNumberRestrictions["default"], {
    settings: settings,
    setSettings: setSettings
  })), showUserGroupRestrictions && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("hr", {
    className: "mt-4"
  }), /*#__PURE__*/_react["default"].createElement(_UserGroupRestrictions["default"], {
    settings: settings,
    setSettings: setSettings
  })));
};

var _default = LeftPanel;
exports["default"] = _default;